import { Translate } from "@/app/application/Translate";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { format } from "date-fns";
import { useField } from "formik";

interface Props extends React.DetailedHTMLProps<
	React.InputHTMLAttributes<HTMLInputElement>,
	HTMLInputElement
> {
	label: string;
	name: string;
	type: string;
	id: string;
	value?: string;
	rows?: number;
	placeholder?: string;
	translationString?: string;
}

const CustomInput = ({ label, id, translationString, ...props }: Props) => {
	const [field, meta] = useField(props);
	const theme = useTheme();

	if (props.type === "date") {
		field.value = format(new Date(field.value), "yyyy-MM-dd");
	}

	const hasError = meta.touched && meta.error;
	return (
		<div className="input-container">
			<InputLabel
				htmlFor={id}
				sx={{ color: "text.secondary", mb: 0.5, display: "block" }}
			>
				<Translate String={translationString || ""}>{label}</Translate>
			</InputLabel>
			<input
				id={id}
				{...field}
				{...props}
				className={hasError ? "input-error" : ""}
				style={{
					width: "100%",
					padding: "8px 12px",
					borderRadius: 8,
					fontSize: "1rem",
					backgroundColor: theme.palette.background.paper,
					color: theme.palette.text.primary,
					border: "1px solid",
					borderColor: hasError
						? theme.palette.error.main
						: theme.palette.divider,
				}}
			/>
			{hasError && (
				<Typography
					variant="caption"
					sx={{ color: "error.main", mt: 0.5, display: "block" }}
				>
					{meta.error}
				</Typography>
			)}
		</div>
	);
};

export default CustomInput;
